const WORK_DATA = [
	{
		title: 'Joe N. Brown Art',
		description: 'Website',
		image: 'joe.png',
		gridArea: 'joe',
		route: '/JoeNBrownArt'
	},
	{
		title: 'Breathe Calm',
		description: 'iOS and Android App',
		image: 'breathe.png',
		gridArea: 'breathe',
		route: '/BreatheCalm'
	},
	{
		title: 'SpentAll',
		description: 'Web App',
		image: 'SpentAll.png',
		gridArea: 'spent',
		route: '/SpentAll'
	},
	{
		title: 'Too Far East',
		description: 'Website',
		image: 'TFE.png',
		gridArea: 'too',
		route: '/TooFarEastBarber'
	},
	{
		title: 'NRS Tele',
		description: 'Tablet + Mobile App',
		image: 'tele.png',
		gridArea: 'tele',
		route: '/NetRoadshowTeleprompter'
	},
	{
		title: 'NRS Mini',
		description: 'Wechat Miniprogram',
		image: 'Mini.png',
		gridArea: 'wechat',
		route: '/NetRoadshowMiniprogram'
	},
];

export default WORK_DATA;